import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Paginator } from "primereact/paginator";
import { Ripple } from "primereact/ripple";
import { Nav } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import { TitleContext } from "../../../../Context/TitleContext";
import { API_URL, useAxios, rowsPerPageOptions } from "../../../../utils/const";
import { Toaster } from "react-hot-toast";
import { DeleteModal } from "./DeleteModal";
import CreateModal from "./CreateModal";
import { useToast } from "../../../../Context/ToastContext";
import moment from "moment/moment";
import UpdateModal from "./UpdateModal";
import SearchModal from "./SearchModal";
import RekapModal from "./RekapModal";

const CourseSessionDetail = () => {
  const { setTitle } = useContext(TitleContext);
  const axiosInstance = useAxios();
  const { setToastObj } = useToast();
  const { id } = useParams();

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [openSearchModal, setOpenSearchModal] = useState(false);
  const [openRekapModal, setOpenRekapModal] = useState(false);

  const [courseType, setCourseType] = useState("");
  const [course, setCourse] = useState();
  const [courseTopics, setCourseTopics] = useState([]);
  const [courseStudents, setCourseStudents] = useState([]);
  const [courseLecturers, setCourseLecturers] = useState([]);

  const [courseGroupTimetables, setCourseGroupTimetables] = useState([]);
  const [courseGroupTimetableRecords, setCourseGroupTimetableRecords] =
    useState([]);
  const [selectedCourseGroupTimetable, setSelectedCourseGroupTimetable] =
    useState([]);

  const [classrooms, setClassrooms] = useState([]);

  const [key, setKey] = useState("");
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({ first: 0, rows: 10, page: 0 });
  const [isRendered, setIsRendered] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingInfoBasic, setLoadingInfoBasic] = useState(true);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  useEffect(() => {
    setTitle("USAKTI | Man. Jadwal Kelas"); // Set judul halaman
  }, [setTitle]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingInfoBasic(true);
        await getCourseById(id);
        await getCourseTopics();
        await getClassrooms();
        await getCourseStudents();
        await getCourseLecturers();
      } catch (error) {
        setToastObj({
          msg: error,
          type: "danger",
        });
      } finally {
        setLoadingInfoBasic(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (isRendered) {
        try {
          setLoading(true);
          await getCourseSessions();
        } catch (error) {
          setToastObj({
            msg: error,
            type: "danger",
          });
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [pagination, key]);

  const toggleOpenCreateModal = () => {
    setOpenCreateModal(true);
  };

  const toggleOpenDeleteModal = (e) => {
    setSelectedCourseGroupTimetable(e);
    setOpenDeleteModal(true);
  };

  const toggleOpenUpdateModal = (e) => {
    setSelectedCourseGroupTimetable(e);
    setOpenUpdateModal(true);
  };

  const getCourseById = async (id) => {
    const response = await axiosInstance.get(`${API_URL}/courses/${id}`);
    setCourse(response.data.data);
  };

  const getCourseSessions = async () => {
    const courseGroupTimetablesTemp = {};
    const data = {
      courseType: courseType,
      fromDate: fromDate,
      toDate: toDate,
    };

    const limit = pagination.rows === "All" ? -1 : pagination.rows;

    for (const item of course.courseGroups) {
      const response = await axiosInstance.post(
        `${API_URL}/course-sessions/${item.id}?page=${
          pagination.page + 1
        }&limit=${limit}`,
        data
      );
      courseGroupTimetablesTemp[item.group.name] = {
        courseGroupTimetables: response.data.data.courseGroupTimetables,
        totalRecords: response.data.data.totalRecords,
      };
    }

    setCourseGroupTimetables(courseGroupTimetablesTemp);
    setCourseGroupTimetableRecords(courseGroupTimetablesTemp[`${key}`]);
  };

  const getCourseTopics = async () => {
    const response = await axiosInstance.get(
      `${API_URL}/course-topics/${id}?limit=-1`
    );
    setCourseTopics(response.data.data);
  };

  const getClassrooms = async () => {
    const response = await axiosInstance.get(`${API_URL}/classrooms?limit=-1`);
    setClassrooms(response.data.data);
  };

  const getCourseStudents = async () => {
    const response = await axiosInstance.get(
      `${API_URL}/course-students/${id}`
    );
    setCourseStudents(response.data.data.courseGroups);
  };

  const getCourseLecturers = async () => {
    const response = await axiosInstance.get(
      `${API_URL}/course-lecturers/${id}`
    );
    setCourseLecturers(response.data.data.courseGroups);
  };

  const formatDate = (isoDate) => {
    // Format using moment
    return moment(isoDate).format("DD MMMM YYYY");
  };

  function handleRowChange(row) {
    setPagination({ first: 0, rows: row, page: 0 });
  }

  function handleTabChange(courseGroup) {
    setIsRendered(true);
    setKey(courseGroup);
    setPagination({ first: 0, rows: pagination.rows, page: 0 });
  }

  const paginationTemplate = {
    layout: "PrevPageLink PageLinks NextPageLink ",
    PrevPageLink: (options) => {
      return (
        <button
          type="button"
          className="btn border"
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-3">Previous</span>
          <Ripple />
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button
          type="button"
          className="btn border"
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-3">Next</span>
          <Ripple />
        </button>
      );
    },
  };

  const onPageChange = async (event) => {
    setPagination({ first: event.first, rows: event.rows, page: event.page });
  };

  const toggleOpenSearchModal = () => {
    setOpenSearchModal(true);
  };
  const toggleOpenRekapModal = () => {
    setOpenRekapModal(true);
  };

  return loadingInfoBasic == false ? (
    <div>
      <Toaster position="top-right" />
      <div className="container-fluid">
        <div className="card mb-4">
          <div className="card-body">
            <h1>Detail Jadwal Kelas</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link>Man. Jadwal Kelas</Link>
              </li>
            </ol>
          </div>
        </div>

        <div className="card">
          <div className="card-body m-3">
            <div
              className="row justify-content-between"
              style={{ margin: "20px 0" }}
            >
              <div className="col-md-12 text-start table-responsive">
                <table style={{ width: "650px" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "175px" }}>Kode MK</td>
                      <td>: {course.kode_mk}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "175px" }}>Modul</td>
                      <td>: {course.name}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "175px" }}>Semester</td>
                      <td>: {course.semester.name}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "175px" }}>Kelompok Modul</td>
                      <td>
                        :{" "}
                        {course.courseGroups.length > 0
                          ? course.courseGroups
                              .map((item) => item.group.name)
                              .join(", ")
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-bold" style={{ width: "175px" }}>
                        Total Peserta
                      </td>
                      <td className="fw-bold">
                        :{" "}
                        {course.courseTotalParticipants.length > 0
                          ? course.courseTotalParticipants[0].total_participants
                          : 0}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 justify-content-end d-flex gap-1">
                <button
                  className="btn btn-success"
                  onClick={toggleOpenCreateModal}
                >
                  + Tambah
                </button>
                <button
                  className="btn btn-primary text-white me-2"
                  onClick={toggleOpenRekapModal}
                >
                  Rekap <i class="fa fa-file-excel"></i>
                </button>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-4 text-center offset-md-4">
                <h4>{`Kelompok ${key}`}</h4>
              </div>
            </div>

            <div className="row">
              <Tab.Container
                activeKey={key}
                onSelect={(k) => handleTabChange(k)}
              >
                <Nav variant="pills" className="mb-3">
                  {course.courseGroups.map((item) => (
                    <Nav.Item>
                      <Nav.Link eventKey={item.group.name}>
                        Kelompok {item.group.name}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>

                {/* TAB CONTENT */}
                {loading == false ? (
                  <Tab.Content>
                    {course.courseGroups.map((item) => (
                      <Tab.Pane eventKey={item.group.name}>
                        {/* SEARCH */}
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label>Show</label>
                            <select
                              value={pagination.rows}
                              onChange={(e) => handleRowChange(e.target.value)}
                              className="form-select form-select-sm d-inline-block w-auto ms-2"
                            >
                              {rowsPerPageOptions.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                            <label style={{ marginLeft: "5px" }}>entries</label>
                          </div>
                          <div className="col-md-6 text-end">
                            <button
                              className="btn btn-primary text-white me-2"
                              onClick={toggleOpenSearchModal}
                            >
                              Filter
                            </button>
                          </div>
                        </div>

                        {/* Tabel Data Jadwal Kelas */}
                        <div className="table-responsive">
                          <table className="table table-striped mt-3">
                            <thead>
                              <tr>
                                <th>NO</th>
                                <th>
                                  <div
                                    className="d-flex gap-3"
                                    style={{ alignItems: "center" }}
                                  >
                                    <span>TANGGAL</span>
                                    <i
                                      className="fa fa-calendar"
                                      style={{
                                        color: "red",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => setOpenSearchModal(true)}
                                    ></i>
                                  </div>
                                </th>
                                <th>JAM</th>
                                <th>TOPIK</th>
                                <th>TIPE</th>
                                <th>RUANGAN</th>
                                <th>PENGAJAR</th>
                                <th>STATUS</th>
                                <th className="text-center">AKSI</th>
                              </tr>
                            </thead>
                            <tbody>
                              {courseGroupTimetableRecords.courseGroupTimetables !==
                                undefined &&
                                courseGroupTimetableRecords.courseGroupTimetables.map(
                                  (
                                    courseGroupTimetable,
                                    courseGroupTimetableIndex
                                  ) => (
                                    <tr key={courseGroupTimetableIndex}>
                                      <td>
                                        {pagination.first +
                                          courseGroupTimetableIndex +
                                          1}
                                      </td>
                                      <td>
                                        {formatDate(courseGroupTimetable.date)}
                                      </td>
                                      <td>
                                        {courseGroupTimetable.start_time} -{" "}
                                        {courseGroupTimetable.end_time}
                                      </td>
                                      <td className="align-middle">
                                        {courseGroupTimetable.courseTopic.topic}
                                      </td>
                                      <td className="align-middle">
                                        {courseGroupTimetable.course_type}
                                      </td>
                                      <td className="align-middle">
                                        {courseGroupTimetable.classroom.name}
                                      </td>
                                      <td className="align-middle">
                                        {courseGroupTimetable.lecturers
                                          .map(
                                            (lecturer) => lecturer.lecturer.name
                                          )
                                          .join(", ")}
                                      </td>
                                      <td className="align-middle">
                                        {courseGroupTimetable.status === 0 ? (
                                          <span className="badge text-white text-bg-info">
                                            ON SCHEDULE
                                          </span>
                                        ) : courseGroupTimetable.status ===
                                          1 ? (
                                          <span className="badge text-white text-bg-warning">
                                            ON GOING
                                          </span>
                                        ) : courseGroupTimetable.status ===
                                          2 ? (
                                          <span className="badge text-white text-bg-success">
                                            FINISHED
                                          </span>
                                        ) : courseGroupTimetable.status ===
                                          3 ? (
                                          <span className="badge text-white text-bg-danger">
                                            CANCELED
                                          </span>
                                        ) : (
                                          <span className="badge text-white text-bg-secondary">
                                            UNKNOWN
                                          </span>
                                        )}
                                      </td>
                                      <td className="text-center align-middle">
                                        <div className="d-flex gap-1">
                                          <Link
                                            to={{
                                              pathname: `/akademik/course-attendances/${courseGroupTimetable.id}/${courseGroupTimetable.course_type}`,
                                            }}
                                            className="btn btn-success text-white btn-sm"
                                          >
                                            <i className="fa-regular fa-clock"></i>
                                          </Link>
                                          <button
                                            className="btn btn-warning text-white btn-sm"
                                            onClick={() =>
                                              toggleOpenUpdateModal(
                                                courseGroupTimetable
                                              )
                                            }
                                          >
                                            <i className="fas fa-pen-square"></i>
                                          </button>
                                          {courseGroupTimetable.status === 3 ||
                                            (courseGroupTimetable.status ===
                                              0 && (
                                              <button
                                                className="btn btn-danger text-white btn-sm"
                                                onClick={() =>
                                                  toggleOpenDeleteModal(
                                                    courseGroupTimetable
                                                  )
                                                }
                                              >
                                                <i className="fas fa-trash"></i>
                                              </button>
                                            ))}
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )}
                            </tbody>
                          </table>
                        </div>
                        {/* Paginator dari PrimeReact */}
                        <div className="row">
                          <div className="col-md-6 d-flex align-items-center h-100">
                            <p>
                              Showing {pagination.first + 1} to{" "}
                              {pagination.rows >
                              courseGroupTimetableRecords.totalRecords
                                ? courseGroupTimetableRecords.totalRecords
                                : pagination.rows}{" "}
                              of {courseGroupTimetableRecords.totalRecords}{" "}
                              entries
                            </p>
                          </div>
                          <div className="col-md-6">
                            <Paginator
                              first={pagination.first}
                              rows={
                                pagination.rows === "All"
                                  ? courseGroupTimetableRecords.totalRecords
                                  : pagination.rows
                              }
                              totalRecords={
                                courseGroupTimetableRecords.totalRecords
                              }
                              onPageChange={onPageChange}
                              template={paginationTemplate}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                ) : (
                  <></>
                )}
              </Tab.Container>
            </div>
          </div>
        </div>
        {openCreateModal && (
          <CreateModal
            toggleModal={setOpenCreateModal}
            courseId={id}
            getCourseSessions={getCourseSessions}
            courseGroups={course.courseGroups}
            courseTopics={courseTopics}
            courseStudents={courseStudents}
            courseLecturers={courseLecturers}
            classrooms={classrooms}
          />
        )}

        {openUpdateModal && (
          <UpdateModal
            toggleModal={setOpenUpdateModal}
            courseId={id}
            getCourseSessions={getCourseSessions}
            courseGroups={course.courseGroups}
            courseTopics={courseTopics}
            courseLecturers={courseLecturers}
            classrooms={classrooms}
            courseStudents={courseStudents}
            selectedCourseGroupTimetable={selectedCourseGroupTimetable}
          />
        )}
        {openDeleteModal && (
          <DeleteModal
            toggleModal={setOpenDeleteModal}
            getCourseSessions={getCourseSessions}
            courseSession={selectedCourseGroupTimetable}
          />
        )}

        {openSearchModal && (
          <SearchModal
            toggleModal={setOpenSearchModal}
            setCourseType={setCourseType}
            courseType={courseType}
            setFromDate={setFromDate}
            fromDate={fromDate}
            setToDate={setToDate}
            toDate={toDate}
            setPagination={setPagination}
          />
        )}
        {openRekapModal && (
          <RekapModal
            toggleModal={setOpenRekapModal}
            setCourseType={setCourseType}
            courseType={courseType}
            setFromDate={setFromDate}
            fromDate={fromDate}
            setToDate={setToDate}
            toDate={toDate}
            courseId={id}
          />
        )}
      </div>
    </div>
  ) : (
    <div>
      <div className="row">
        <div
          className="col-md-12 text-center align-center"
          style={{ marginTop: "20%" }}
        >
          <h1>Mohon Tunggu</h1>
        </div>
      </div>
    </div>
  );
};

export default CourseSessionDetail;
